import { authenticationSlice } from '../reducers/authentication-reducer';
export const { loggedIn, loggedOut } = authenticationSlice.actions;
